export default function getGenresURL(): string {
  return `/api/utility/genres`;
}
